export type ItemListOrigin = {
  item_list_id: string;
  item_list_name: string;
  item_id?: string;
  item_slug?: string;
};

const STORAGE_KEY = "blu_item_list_origin";

export function setItemListOrigin(origin: ItemListOrigin): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(origin));
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

export function getItemListOrigin(): ItemListOrigin | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ItemListOrigin;
  } catch {
    return null;
  }
}

export function clearItemListOrigin(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
}

export function getMatchingItemListOrigin(product: {
  id?: string | null;
}): ItemListOrigin | null {
  const origin = getItemListOrigin();
  if (!origin) return null;

  const matchesId = origin.item_id && origin.item_id === product.id;

  if (!matchesId) {
    clearItemListOrigin();
    return null;
  }

  return origin;
}
